var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspaceMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23809",
    "data-name": "Group 23809",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.905,
    height: 31.391,
    viewBox: "0 0 36.905 31.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4259711"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3721",
    "data-name": "Rectangle 3721",
    width: 36.906,
    height: 31.391,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23787",
    "data-name": "Group 23787",
    clipPath: "url(#clip-path-4259711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22161",
    "data-name": "Path 22161",
    d: "M34.793,0h-20.2A2.092,2.092,0,0,0,12.5,2.092v7.86H2.092A2.1,2.1,0,0,0,0,12.044V25.318A2.1,2.1,0,0,0,2.092,27.41H6.084l-.1,3.264a.711.711,0,0,0,.345.633.822.822,0,0,0,.723,0L14.1,27.394h8.361A2.092,2.092,0,0,0,24.553,25.3V19.057h1.209l5.574,3.93a.822.822,0,0,0,.744.049.707.707,0,0,0,.411-.637V19.057h2.323a2.092,2.092,0,0,0,2.092-2.092V2.092A2.092,2.092,0,0,0,34.813,0ZM23.114,25.318a.654.654,0,0,1-.654.654H13.894a.735.735,0,0,0-.349.09c-6.01.453-1.048-8.736-1.048-9.1h0c0-.36.157,1.7.517,1.7L12.5,11.391c-5.18,19.214.447,14.581,1.6,14.581l9.015.218Zm12.332-8.353a.654.654,0,0,1-.654.654H31.751a.719.719,0,0,0-.719.719V21.01l-4.625-3.26A.72.72,0,0,0,26,17.618H14.589a.654.654,0,0,1-.654-.654V2.092a.654.654,0,0,1,.637-.67H34.793a.654.654,0,0,1,.654.654Z",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22162",
    "data-name": "Path 22162",
    d: "M243.088,111.572a1.492,1.492,0,1,0,1.492,1.492,1.492,1.492,0,0,0-1.492-1.492",
    transform: "translate(-223.945 -103.42)",
    fill: "#5e8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22163",
    "data-name": "Path 22163",
    d: "M324.562,111.572a1.492,1.492,0,1,0,1.488,1.5v0a1.488,1.488,0,0,0-1.484-1.492h0",
    transform: "translate(-299.462 -103.42)",
    fill: "#5e8dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22164",
    "data-name": "Path 22164",
    d: "M406.089,111.572a1.492,1.492,0,1,0,1.488,1.5v0a1.488,1.488,0,0,0-1.484-1.492h0",
    transform: "translate(-375.033 -103.42)",
    fill: "#5e8dfa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceMessageIcon);
export default __webpack_public_path__ + "static/media/workspace-message-icon.5d902e42caaa103642dda826001715c4.svg";
export { ForwardRef as ReactComponent };